import React, { Component } from 'react';
import Loader from 'react-loaders';

class OroLoader extends Component {
  render() {
    return (
      <div className={this.props.className + " oro-loader-inline"}>
        <Loader type="ball-clip-rotate" />
      </div>
    );
  }
}

export default OroLoader;
